import React, { useEffect, FC, useRef, useState } from "react";
import { YHModal } from "@/components/YHModal";
import Table, { ColumnsType } from "antd/lib/table";
import { RouterParamType } from "@/model/navModel";
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { YhFormBox } from "@/components/YhFormBox";
import { YhBox } from "@/components/YhBox";
import { Button, Upload, message, Checkbox } from "antd";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { useGlobalModel } from "@/model/globalModel";
import { supplierService } from "@/views/base/supplier/supplierService";
import { ISupplierOfferDetails, ISupplierMaterialDetails } from "../../../enquiryTypes";
import { getFormValidatorErrText, formatNum, formatInt, getRandomStr } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useSupplierOfferModel } from "./supplierOfferModel";
import { importPropsConfig1 } from "@/utils/importFile1";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import {useEnquiryDetailModel} from "../enquiryDetailModel"
export const SupplierDialog: FC<RouterParamType> = (props) => {
    const {
        supplierDialog: { visible, mode },
        materialList, setMaterialList,
        formVal, setFormVal,
        selectedMaterialRowKeys, setSelectedMaterialRowKeys,
        setSupplierDialog,
        setSupplierMaterialDialog,
        insertOrUpdateSupplierOffer,
        getSupplierMaterialOne,
        resetCache,
        exportEnquiry,
        offerDownloadTpl,
        getUploadUrl
    } = useSupplierOfferModel();
    const {addFormVal,editFormVal} = useEnquiryDetailModel()
    const [modifyTotal, setModifyTotal] = useState<boolean>(false)
    const { fetchSupplierList, setLoadingInfo } = useGlobalModel(() => []);
    const formRef = useRef<IYhFormRef>();

    const formVal1 = mode === "edit" ? editFormVal : addFormVal;

    const onCancel = () => {
        setSupplierDialog({ visible: false, mode: "add" })
    };

    //编辑模式下 回显数据
    useEffect(() => {
        if (visible && !formVal.id && mode === "edit") {
            getSupplierMaterialOne()
        }
        !visible && resetCache()
    }, [visible])

    //回显选中供应商带出来的数据
    const getSupplier = async (id: string) => {
        let { retData } = await supplierService.one(id);
        let data = {
            supplierCode: retData.code,
            supplierName: retData.name,
            supplierId: retData.id,
            contact: retData.contact,
            phone: retData.phone
        }
        setFormVal(origin => ({ ...origin, ...data }));
    }

    //客户选中
    const supplierChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getSupplier(option.id as string)
        }
    }

    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: ISupplierOfferDetails) => {
            insertOrUpdateSupplierOffer(mode, val).then(res => {
                res && onCancel()
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const baseFormItem: IYhFormItemsBox = {
        title: "",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "供应商名称",
                fieldName: "supplierId",
                onSelectChange: supplierChange,
                placeholder: "供应商",
                rules: [{ required: true, message: "请选择供应商" }],
                selectfetchList: fetchSupplierList,
                defaultQuery: formVal.supplierName,
                disable:formVal1.status ==='gtm.inquiry.pend'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商报价编码",
                placeholder: "自动带出",
                fieldName: "code",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                placeholder: "自动带出",
                fieldName: "contact",
                disable:formVal1.status ==='gtm.inquiry.pend'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                placeholder: "自动带出",
                fieldName: "phone",
                disable:formVal1.status ==='gtm.inquiry.pend'
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "报价时间",
                fieldName: "createTime",
                // disable: false
                disable:formVal1.status ==='gtm.inquiry.pend'

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属门店",
                fieldName: "shopName",
                // disable: true,
                disable:formVal1.status ==='gtm.inquiry.pend',
                hidden: true
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商编码",
                fieldName: "supplierCode",
                hidden: true
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        boxs: [baseFormItem]
    }

    //导入明细成功
    const upLoadCallback = (list: ISupplierMaterialDetails[]) => {
        setLoadingInfo({ loadingVisible: false, txt: "" });
        if (list && list.length) {
            let dataSource = [...materialList];
            let strArr: string[] = []
            // amount: 2
            // createUser: ""
            // id: ""
            // inquiryOrderDetailsId: "1480513157724336129"
            // materialCode: "LG9705580017"
            // materialEname: "hh"
            // materialName: "组合仪表（24V/柴油共轨/新内饰/彩屏/潍柴国五）"
            // num: 1
            // price: 2
            // shopCode: "SHOP-M-00000102"
            // typeCode: "material-brand.sinotruk-light"
            // typeName: "重汽轻卡"
            // updateUser: ""
            list.forEach(material => {
                //导入的是否存在列表
                let isExist = dataSource.find(item => item.materialCode === material.materialCode);
                if (!isExist) {
                    let { id, ...item } = material;
                    dataSource.push({
                        ...item,
                        "key": getRandomStr(),  //自己用
                        "note": ""         //    // "备注"
                    })
                } else {
                    strArr.push(material.materialName ?? "")
                }
            });
            strArr.length && message.warning(`【${strArr.join()}】重复的配件已做过滤`)
            setMaterialList(dataSource);
        }
    };
    const onChange = (e: CheckboxChangeEvent) => {
        // console.log(`checked = ${e.target.checked}`);
        setModifyTotal(e.target.checked)
    };
    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}> */}
        <Checkbox checked={modifyTotal} onChange={onChange}>不根据单价，数量 计算总价</Checkbox>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setSupplierMaterialDialog(true)}
            disabled={ formVal1.status ==='gtm.inquiry.pend'}
        >新增</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={ formVal1.status ==='gtm.inquiry.pend'}
            onClick={() => {
                if (!selectedMaterialRowKeys.length) {
                    message.warning("请选择你要删除的商品");
                    return;
                }
                setMaterialList(origin => origin.filter(item => selectedMaterialRowKeys.indexOf(item.key ?? "") < 0));
            }}
        >删除</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { offerDownloadTpl() }}
        >下载模板</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_IM}> */}
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig1(getUploadUrl(), upLoadCallback)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={mode === "add"}
            onClick={() => { exportEnquiry() }}
        >导出</Button>
        {/* </YhAuth> */}
    </>

    //子表
    const column = [
        {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'materialEname',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '询价数量',
            width: 100,
            dataIndex: 'num',
            // editable: true
            editable: formVal1.status !=='gtm.inquiry.pend'
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            // editable: true
            editable: formVal1.status !=='gtm.inquiry.pend'
        }, {
            title: '总金额',
            width: 100,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`,
            // editable: true
            editable: formVal1.status !=='gtm.inquiry.pend'
        }, {
            title: '规格',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitName',
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: true
        },
    ];

    const newColumn = column.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        row.num = +formatInt(row.num);
        row.price = formatNum(row.price);
        row.amount = modifyTotal ? formatNum(row.amount) : formatNum(row.num * row.price);
        // row.amount = formatNum(row.num * row.price);
        // row.amount = formatNum(row.amount);
        const tempArr = [...materialList];
        const index = tempArr.findIndex((item) => row.key === item.key);
        const item = tempArr[index];
        tempArr.splice(index, 1, { ...item, ...row });
        setMaterialList(tempArr);
    }

    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        num: materialList.reduce((con, next) => { con = con + +(next?.num ?? 0); return con }, 0),
        amount: materialList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0),
        price: "null"
    }

    return <YHModal
        visible={visible}
        onOk={() => onSubmit()}
        okText="保存"
        onCancel={onCancel}
        title={`供应商报价${mode === "edit" ? "编辑" : "新增"}`}
        width={"90%"}
        bodyHeight={700}
        showFooter={true}
        maskClosable={false}
    >
        <YhFormBox {...stockEntryFromConfig} />
        <YhBox title=" " style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    // hideSelectAll: true,
                    selectedRowKeys: selectedMaterialRowKeys, //记录选中
                    getCheckboxProps: (record) => {
                        let checkboxProps: any = {};
                        if (record.key === "totalAmount") {
                            checkboxProps.disabled = true;
                        }
                        return checkboxProps;
                    },
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISupplierMaterialDetails[]) => {
                        setSelectedMaterialRowKeys(selectedRowKeys.filter(item => item !== "totalAmount") as string[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumn as ColumnsType<any>}
                dataSource={materialList.length > 0 ? [...materialList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 460 }}
            />
        </YhBox>
    </YHModal>
}